export default {
  translation: {
    CLIENT_PORTAL: 'Gátt viðskiptavinar',
    SIGN_OUT: 'Útskrá',
    TERMS_AND_CONDITIONS: 'Skilmálar og skilyrði',
    TERMS_AND_CONDITIONS_UPDATED: '(uppfært {{-termsAndConditionDate}})',
    TAB_MY_ACCOUNT: 'Mínar síður',
    TAB_KORTA_TRANSACTIONS: 'Færslur',
    TAB_KORTA_AUTHORISATIONS: 'Heimildir',
    TAB_KORTA_CLEARED_TRANSACTIONS: 'Fjárhagsfærslur',
    TAB_KORTA_SETTLEMENTS: 'Uppgjör',
    TAB_KORTA_SETTLED_PAYMENTS: 'Uppgerðar greiðslur',
    TAB_KORTA_UNSETTLED_PAYMENTS: 'Óuppgerðar greiðslur',
    TAB_KORTA_ICELANDIC_PAYMENTS: 'Íslenskar greiðslur',
    TAB_KORTA_INCOMING_BATCH: 'Bunkar inn',
    TAB_KORTA_OUTGOING_BATCH: 'Bunkar út',
    TAB_ACCOUNTING_FILES: 'Bókhaldsskrár',
    TAB_KORTA_AGREEMENTS: 'Samningar',
    TAB_KORTA_ACQUIRING_CONTRACTS: 'Kortasamningar',
    TAB_KORTA_MERCHANT_AGREEMENTS: 'Rammasamningar',
    TAB_KORTA_SETTLEMENT_ACCOUNTS: 'Uppgjörsreikningar',
    TAB_KORTA_DISPUTES: 'Ágreiningsmál',
    TAB_KORTA_CHARGEBACKS: 'Endurkröfur',
    TAB_KORTA_FRAUDS: 'Svik',
    SETTINGS: 'Stillingar',
    TEST_DATA_BANNER: 'Prófgögn',
    KORTA_DASHBOARD_SALES_TODAY: 'Sala í dag',
    KORTA_DASHBOARD_REJECTIONS_TODAY: 'Höfnun í dag',
    KORTA_DASHBOARD_TOTAL_SALES_TODAY: 'Heildarsala í dag',
    KORTA_TABLE_ERROR: 'Villa kom upp! Vinsamlegast reyndu aftur síðar',
    CANCEL_SUBSCRIPTION: 'Hætta við áskrift',
    RENEW_SUBSCRIPTION: 'Endurnýja áskrift',
    ADD_CARD: 'Bættu við korti',
    HEADER_MY_ACCOUNT: 'Persónuupplýsingar',
    LABEL_FULL_NAME: 'Fullt nafn',
    LABEL_PHONE_NUMBER: 'Símanúmer',
    LABEL_EMAIL: 'Netfang',
    LABEL_PASSWORD: 'Lykilorð',
    MY_ACCOUNT_CANCEL_BTN: 'Hætta við',
    MY_ACCOUNT_SAVE_BTN: 'Vista',
    SEARCH: 'Leita',
    PAYMENT_CHOOSE_COLUMNS_TOOLTIP: 'Velja dálka',
    NOTHING_TO_SEE_HERE: 'Ekkert að sjá hér',
    QUERY_NO_RESULT: 'Þessi fyrirspurn skilaði engum niðurstöðum',
    CHOOSE_COLS: 'Velja dálka',
    CHOOSE_COLS_PANEL_CANCEL_BTN: 'Hætta við',
    CHOOSE_COLS_PANEL_APPLY_BTN: 'Virkja',
    KORTA_FOUND_RECORDS: 'Fann {{value}} skrár',
    KORTA_TOTAL_PAYMENT_AMOUNT: 'Samtals „Upphæð“: {{value}} ',
    PRINT: 'Prenta',
    EXPORT_EXCEL: 'Xslx',
    EXPORT_PDF: 'PDF',
    EXPORT_CSV: 'CSV',

    // My Account - Edit password
    EDIT_PASSWORD_MODAL_TITLE: 'Breyta lykilorði',
    EDIT_PASSWORD_LABEL_CURRENT: 'Núverandi lykilorð',
    EDIT_PASSWORD_LABEL_NEW: 'Nýtt lykilorð',
    EDIT_PASSWORD_LABEL_RETYPE: 'Nýtt lykilorð aftur',
    EDIT_PASSWORD_SAVE_BTN: 'Vista nýtt lykilorð',
    EDIT_PASSWORD_INVALID_PASSWORD_SHORT: 'Lykilorð má ekki vera styttra en 8 stafir',
    EDIT_PASSWORD_INCORRECT_PASSWORDS: 'Lykilorðin eru ekki eins',

    // Enter 2fa - wizard
    ENTER_2FA_INCORRECT_CODE: 'Rangur kóði',
    ENTER_2FA_ALERT_3_TIMES: 'Eitthvað fór úrskeiðis, vinsamlegast reyndu aftur síðar',
    ENTER_2FA_TITLE: 'Vinsamlegast sláðu inn kóða',

    ENTER_2FA_CONTENT_1: `SMS skilaboð með 6-stafa auðkenningarkóða voru send í símanúmer`,
    ENTER_2FA_CONTENT_1_LOGIN: `SMS skilaboð með 6-stafa auðkenningarkóða voru send í símanúmer {{phone_numer}}. Vinsamlegast sláðu inn kóðann til að auðkenna símanúmerið.`,
    ENTER_2FA_CONTENT_OTP: `SMS skilaboð með 6-stafa auðkenningarkóða voru send í símanúmer {{phone_numer}}. Vinsamlegast sláðu inn kóðann til að auðkenna símanúmerið.`,
    ENTER_2FA_CONTENT_3: 'Vinsamlegast sláðu inn kóðann til að auðkenna símanúmerið.',
    ENTER_2FA_CONTENT_3_LOGIN: 'Vinsamlegast sláðu inn kóðann til að auðkenna símanúmerið.',

    ENTER_2FA_BTN: 'Auðkenna númer',
    ENTER_2FA_RESEND_BTN: 'Endursenda SMS',

    KORTA_AUTHORIZATION_CONTRACT_INFORMATION: 'Samningsupplýsingar',
    KORTA_AUTHORIZATION_MERCHANT_ID: 'Auðkenni rammasamnings',
    KORTA_AUTHORIZATION_ACQUIRING_CONTRACT_ID: 'Auðkenni kortasamnings',
    KORTA_AUTHORIZATION_AUTHORISATION_SUMMARY: 'Yfirlit heimildar',
    KORTA_AUTHORIZATION_AUTHORISATION_CODE: 'Heimild',
    KORTA_AUTHORIZATION_FINAL_RESPONSE: 'Svörun',
    KORTA_AUTHORIZATION_STATUS: 'Staða',
    KORTA_AUTHORIZATION_TRANSACTION_SUMMARY: 'Yfirlit færslu',
    KORTA_AUTHORIZATION_TYPE: 'Tegund heimildar',
    KORTA_AUTHORIZATION_TERMINAL_ID: 'Auðkenni útstöðvar',
    KORTA_AUTHORIZATION_REQUEST_TIME: 'Greiðsla framkvæmd',
    KORTA_AUTHORIZATION_TERMINAL_TIME: 'Tími útstöðvar',
    KORTA_AUTHORIZATION_REFERENCE: 'Tilvísun',
    KORTA_AUTHORIZATION_SETTLEMENT_REFERENCE: 'Uppgjörs tilvísun',
    KORTA_AUTHORIZATION_AMOUNT: 'Upphæð',
    KORTA_AUTHORIZATION_CVC: 'CVC',
    KORTA_AUTHORIZATION_CARDHOLDER_DATA: 'Upplýsingar um korthafa',
    KORTA_AUTHORIZATION_CARD_TYPE: 'Kortategund',
    KORTA_AUTHORIZATION_CARD_EXPIRATION_DATE: 'Gildistími korts',
    KORTA_AUTHORIZATION_IP_INFORMATION: 'Upplýsingar um IP-tölu',
    KORTA_AUTHORIZATION_REMOTE_IP: 'Remote IP',
    KORTA_AUTHORIZATION_CLIENT_IP: 'Client IP',
    KORTA_AUTHORIZATION_AUTHORISATION_DETAILS: 'Nánar um heimild',
    NOT_AVAILABLE: 'Ekki tiltækt',
    KORTA_AUTHORIZATION_POS_DATA_CODE: 'POS gagnakóði',
    KORTA_AUTHORIZATION_DATA_CODE: 'Gagnakóði',
    KORTA_AUTHORIZATION_TRANSACTION_ENTRY_MODE: 'Innkoma færslu',
    KORTA_AUTHORIZATION_TERMINAL_CAPABILITY: 'Möguleikar útstöðvar',
    AUTHORIZATION_POSITION: 'Staða',
    AUTHORIZATION_DESCRIPTION: 'Lýsing',
    AUTHORIZATION_VALUE: 'Gildi',
    AUTHORIZATION_VALUE_DESCRIPTION: 'Gildislýsing',
    KORTA_TRANSACTION_CONTRACT_INFORMATION: 'Samningsupplýsingar',
    KORTA_TRANSACTION_MERCHANT_NAME: 'Nafn rammasamnings',
    KORTA_TRANSACTION_MERCHANT_DAILY_NAME: 'Daglegt nafn rammasamnings',
    KORTA_TRANSACTION_ACQUIRING_CONTRACT_ID: 'Auðkenni kortasamnings',
    KORTA_TRANSACTION_SUMMARY: 'Yfirlit yfir færslu',
    KORTA_TRANSACTION_TRANSACTION_DATE: 'Færsludagur',
    KORTA_TRANSACTION_TRANSACTION_TIME: 'Tími færslu',
    KORTA_TRANSACTION_CARD_TYPE: 'Kortategund',
    KORTA_TRANSACTION_AMOUNT: 'Upphæð',
    KORTA_TRANSACTION_CURRENCY: 'Gjaldmiðill',
    KORTA_TRANSACTION_TRANSACTION_TYPE: 'Tegund færslu',
    KORTA_TRANSACTION_TYPE_EXTENSION: 'Framlenging tegundar',
    KORTA_TRANSACTION_TRANSACTION_IDENTITY: 'Færslunúmer',
    KORTA_TRANSACTION_ARN: 'ARN',
    KORTA_TRANSACTION_TRANSACTION_REFERENCE: 'Tilvísun færslu',
    KORTA_TRANSACTION_TRANSACTION_ID: 'Færslunúmer',
    KORTA_TRANSACTION_AUTHORISATION_CODE: 'Heimild',
    KORTA_TRANSACTION_TRANSACTION_ORIGIN: 'Uppruni færslu',
    KORTA_TRANSACTION_OUTGOING_BATCH_STAMP: 'Auðkenni útbunka',
    KORTA_TRANSACTION_INCOMING_BATCH_STAMP: 'Auðkenni innbunka',
    KORTA_TRANSACTION_TERMINAL_ID: 'Auðkenni útstöðvar',
    KORTA_TRANSACTION_STORE: 'Store',
    KORTA_TRANSACTION_TERMINAL: 'Útstöð',
    KORTA_TRANSACTION_3DS_SECURE: '3DS Öryggi',
    KORTA_TRANSACTION_AUTHENTICATION_CODE: 'Auðkenningarkóði',
    KORTA_TRANSACTION_AUTHENTICATION_DESCRIPTION: 'Lýsing auðkenningar',
    KORTA_TRANSACTION_AUTHENTICATION_VALUE: 'Auðkenningargildi',
    KORTA_TRANSACTION_CARDHOLDER_DATA: 'Upplýsingar um korthafa',
    KORTA_TRANSACTION_CARD_NUMBER: 'Kortanúmer',
    KORTA_TRANSACTION_CARD_EXPIRATION_DATE: 'Gildistími korts',
    KORTA_TRANSACTION_TRANSACTION_PRODUCT_DATA: 'Gögn færslu',
    KORTA_TRANSACTION_SCHEME: 'Skema',
    KORTA_TRANSACTION_PRODUCT_PLATFORM_TYPE: 'Product platform type',
    KORTA_TRANSACTION_PRODUCT_PLATFORM: 'Product Platform',
    KORTA_TRANSACTION_FUNDING_SOURCE_TYPE: 'Funding source type',
    KORTA_TRANSACTION_FUNDING_SOURCE: 'Funding source',
    KORTA_TRANSACTION_REGION: 'Svæði færslu',
    KORTA_TRANSACTION_MERCHANT_COUNTRY: 'Land rammasamnings',
    KORTA_TRANSACTION_ISSUER_COUNTRY: 'Land útgefanda',
    KORTA_TRANSACTION_IS_INTRA_EEA: 'Er innan EEA',
    KORTA_TRANSACTION_CROSS_REGION_TYPE: 'Cross region type',
    KORTA_TRANSACTION_CROSS_REGION_DESCRIPTION: 'Cross region description',
    KORTA_TRANSACTION_GLOBAL_WHOLE_SALE: 'Heildarsala á heimsvísu',
    KORTA_TRANSACTION_IS_GLOBAL_WHOLE_SALE: 'Er heildarsala á heimsvísu',
    KORTA_TRANSACTION_DETAILS: 'Nánar um færslu',
    TRANSACTION_DETAILS_TRANSACTIONS_TAB: 'Færsla',
    TRANSACTION_DETAILS_CARD_INFORMATION_TAB: 'Kortaupplýsingar',
    ACCOUNT_SETTINGS: 'Stillingar reiknings',
    TITLE_PAYMENT_METHOD_TYPES: 'Greiðslumátar',
    PAYMENT_METHODS_SETTINGS_MESSAGE:
      'Skoða stöðu greiðslumáta sem eru virkjaðir á reikningnum þínum (safna)',
    TITLE_PAYOUT_METHOD_TYPES: 'Greiðslumátar',
    PAYOUT_METHODS_SETTINGS_MESSAGE:
      'Skoðaðu stöðu greiðslumáta sem eru virkjaðir á reikningnum þínum (afgreiðsla)',
    FX_RATES: 'Gjaldeyrisgengi',
    FX_RATES_SETTINGS_MESSAGE: 'Skoða daglega grunnvexti sem notaðir eru við gjaldeyrisskipti',
    BRANDING: 'Vörumerkjaþróun',
    BRANDING_SETTINGS_MESSAGE:
      'Sérsníða útlit og virkni þinna afgreiðslusíðna sem hýstar eru hjá Rapyd',
    PLUGINS: 'Viðbætur',
    PLUGINS_SETTINGS_MESSAGE: 'Skoða og virkja tiltækar viðbætur frá þriðja aðila',
    TAB_USERS_ROLES: 'Notendur og hlutverk',
    SETTLEMENTS_USERS_MESSAGE: 'Bjóða notendum og stjórna heimildum þeirra',
    TAB_AUDITING: 'Endurskoðunarskrá',
    SETTLEMENTS_AUDIT_MESSAGE:
      'Skoða allar aðgerðir sem notendur framkvæma í viðskiptavinagáttinni',
    TAB_KORTA_ACCOUNTING_SETUP: 'Uppsetning bókhalds',
    KORTA_ACCOUNTING_SETUP_MESSAGE:
      'Stilla uppgjörsskýrslur þannig að þær samrýmist bókhaldshugbúnaði þínum',
    TABLE_HEADER_FULLNAME: 'Fullt nafn',
    TABLE_HEADER_EMAIL: 'Netfang',
    TABLE_HEADER_ROLE: 'Hlutverk',
    TABLE_HEADER_UPDATED_AT: 'Dags. uppfært',
    CREATED_AT: 'Dags. skráð',
    TITLE_USERS_ROLES: 'Notendur',
    SUGGESTION_USERS_EMAIL_ADDRESS: 'Netfang notanda',
    TABLE_HEADER_FIRST_NAME: 'Eiginnafn',
    SUGGESTION_USERS_FIRST_NAME: 'Fyrra nafn notanda',
    TABLE_HEADER_LAST_NAME: 'Eftirnafn',
    SUGGESTION_USERS_LAST_NAME: 'Eftirnafn notanda',
    SUGGESTED_FILTERS: 'Tillögur að síum',
    PLACEHOLDER_SEARCH: 'Leita…',
    USER_MODAL_HEADER: 'Breyta notanda',
    INVITE_MODAL_ADMIN: 'Kerfisstjóri',
    INVITE_MODAL_EDITOR: 'Ritill',
    INVITE_MODAL_BASIC: 'Einfalt',
    USER_MODAL_FULLNAME: 'Fullt nafn',
    USER_MODAL_EMAIL: 'Netfang',
    USER_MODAL_ROLE: 'Velja hlutverk',
    USER_MODAL_REMOVE: 'Fjarlægja',
    USER_MODAL_SAVE: 'Vista',
    NO_RESULT_FOUND: 'Engar niðurstöður fundust',
    MESSAGE_MODAL_CLOSE: 'Loka',
    SAVE: 'Vista',
    form_validators_errors: {
      required: 'Nauðsynlegt',
      max_length: 'Verður að vera {{value}} stafir eða færri',
      exact_length: 'Verður að vera {{value}} stafir',
      illegalDateRange: '"Frá" dagsetning verður að vera á undan "til" dagsetningunni',
      dateRangeTooLarge: 'Tímabil sem leitað er eftir má mest vera {{value}} mánuðir',
    },
    korta_authorisations: {
      header: 'Heimildir',
      id: 'Nánar',
      merchantId: 'Auðkenni rammasamnings',
      terminalId: 'Útstöð',
      reference: 'Tilvísun',
      amount: 'Upphæð',
      currency: 'Gjaldmiðill',
      type: 'Tegund',
      authorisationCode: 'Heimild',
      settlementReference: 'Bunka tilvísun',
      requestTime: 'Tími beiðni',
      actionCode: 'Svar kóði',
      cardType: 'Kortategund',
      status: 'Staða',
      general_search: 'Almenn leit',
      arn: 'ARN',
      arn_placeholder: 'Leita eftir ARN númeri (23 stafir)',
      merchantIdDropDown: 'Rammasamningur',
      acquiringContractId: 'Kortasamningar',
      terminalDropDown: 'Útstöð',
      authType: 'Tegund',
      sale: 'Sala',
      refund: 'Endurgreiða',
      authStatus: 'Heimildarstaða',
      inProgress: 'Í ferli',
      authorised: 'Heimilað',
      captured: 'Tekið',
      sent: 'Sent',
      captureDiffAmount: 'Náði mismunandi magni',
      re_auth: 'Endurheimild',
      reject: 'Hafnað',
      from: 'Frá*',
      to: 'Til*',
      fromTime: 'Frá tíma*',
      toTime: 'Til tíma*',
      referenceField: 'Tilvísun*',
      arnField: 'ARN*',
    },
    korta_merchant_agreements: {
      general_search: 'almenn_leit',
      MERCHANT_DROPDOWN: 'Rammasamningur',
      MERCHANT: 'Rammasamningur',
      MERCHANT_ID: 'Auðkenni rammasamnings',
      NAME: 'Nafn',
      DAILY_NAME: 'Daglegt nafn',
      SSN: 'Kennitala',
      ADDRESS: 'Heimilisfang',
      CONTACT: 'Tengiliður',
      EMAIL: 'Netfang',
      PHONE: 'Sími',
    },
    korta_acquiring_contracts: {
      MERCHANT_DROPDOWN: 'Rammasamningur',
      ACQUIRING_CONTRACT_ID: 'Kortasamningar',
      MERCHANT: 'Rammasamningur',
      MERCHANT_CATEGORY: 'Tegund viðskipta (MCC)',
      RETAINER_RULE: 'Tryggingaregla',
      RETAINER_DAYS: 'Fjöldi tryggingardaga',
      RETAINER_PERCENTAGE: 'Hlutfall tryggingar',
      SETTLEMENT_RULES: 'Uppgjörsreglur',
      PAYMENT_RULE: 'Greiðsluregla',
      DYNAMIC_PERIOD: 'Breytilegt tímabil',
      PAYMENT_DAYS: 'Fjöldi daga',
      WEEKLY_RULE: 'Vikuregla',
      DELIVERY_DATE_RULE: 'Regla um afhendingardag',
      BASE_RULE: 'Grunnregla',
      SERVICE_CHARGE: 'Söluþóknun',
      TYPE_OF_SERVICE_CHARGE: 'Tegund þóknunar',
      GENERAL_SERVICE_CHARGE: 'Almenn þóknun (%)',
      COMMERCIAL_CARD_FEE: 'Þóknun viðskiptakorta (%)',
      GLOBAL_WHOLE_SALE_FEE: 'Þóknun heildsölu (%)',
      REFUND_SERVICE_CHARGE: 'Þóknun endurgreiðslu (%)',
      ORIGINAL_CREDIT_SERVICE_CHARGE: 'Þóknun innborgunar á kort (%)',
      TRANSACTION_FEES: 'Færslugjöld',
      CURRENCY: 'Gjaldmiðill',
      TRANSACTION_FEE: 'Færslugjald',
      REFUND_TRANSACTION_FEE: 'Endurgreiðsla færslugjalds',
      ORIGINAL_CREDIT_TRANSACTION_FEE: 'Færslugjald innborgunar á kort',
      CHARGEBACK_FEE: 'Endurgreiðslugjald',
      AUTHORISATION_FEE: 'Heimildargjald',
      FRAUD_FEE: 'Svikagjald',
      paymentRule: {
        D: 'Daglega',
        W: 'Vikulega',
        M: 'Mánaðarlega',
      },
      weeklyRule: {
        1: 'Mánudag til sunnudags',
        2: 'Þriðjudag til mánudags',
      },
      deliveryDateRule: {
        B: 'Færsludagur',
        D: 'Regla um afhendingardag',
      },
      baseRule: {
        0: 'Fyrsti virki dagur',
        1: 'Síðasti frídagur',
      },
      interchangeRate: {
        0: 'Venjulegt þjónustugjald',
        1: 'Skipti++',
      },
    },
    korta_transactions: {
      header: 'Fjárhagsfærslur',
      details: 'Nánar',
      transactionId: 'Færslunúmer',
      merchantId: 'Auðkenni rammasamnings',
      terminalId: 'Auðkenni útstöðvar',
      transactionReference: 'Tilvísun',
      transactionAmount: 'Upphæð',
      currency: 'Gjaldmiðill',
      transactionType: 'Tegund færslu',
      authorisationCode: 'Heimild',
      terminal: 'Útstöð',
      transactionDate: 'Dagsetning',
      transactionTime: 'Tími',
      maskedPan: 'Kortanúmer',
      actionCode: 'Aðgerðarkóði',
      cardType: 'Kortategund',
      acquiringContractIdField: 'Samningsnúmer',
      inBatch: 'Bunki inn',
      inBatchDate: 'Tími bunka frá pos',
      inBatchReceivedDate: 'Móttökudagur bunka',
      inBatchReceivedTime: 'Móttökutími bunka',
      outBatch: 'Bunki út',
      general_search: 'Almenn leit',
      arn: 'ARN',
      arn_placeholder: 'Leita eftir ARN númeri (23 stafir)',
      merchantIdDropDown: 'Rammasamningur*',
      acquiringContractId: 'Kortasamningar',
      terminalDropDown: 'Útstöð',
      sale: 'Sala',
      refund: 'Endurgreiða',
      from: 'Frá*',
      to: 'Til*',
      referenceField: 'Tilvísun*',
      reference: 'Tilvísun',
      arnField: 'ARN*',
      cardNumber: 'Kortanúmer',
      fromTime: 'Frá tíma*',
      toTime: 'Til tíma*',
      merchantIdDropDownOptional: 'Rammasamningur',
      lengthAllowedValidator: 'Kortanúmer verður að vera með 4, 10 eða 12+ tölustafi',
    },
    korta_settled_payments: {
      header: 'Uppgerðar greiðslur',
      details: 'Nánar',
      chargeCurrency: 'Gjaldmiðill',
      netSettlement: 'Nettó uppgjör',
      deductions: 'Gjöld',
      revenue: 'Tekjur',
      settlementNumber: 'Uppgjörsnúmer',
      settlementDate: 'Uppgjörsdagur',
      acquiringContractDescription: 'Lýsing',
      agreementNumber: 'Samningsnúmer',
      from: 'Frá*',
      to: 'Til*',
      merchantId: 'Rammasamningur',
      acquiringContractId: 'Kortasamningar',
      exportHeader: 'Sækja gögn',
    },
    korta_invoice: {
      SETTLED_PAYMENTS: 'Uppgert',
      UNSETTLED_PAYMENTS: 'Óuppgert',
      UNSETTLED_MESSAGE:
        '* Uppgjörsupphæðin er áætluð. Upphæðin sem greidd er út mun breytast við lokauppgjör.',
      SUMMARY: 'Samantekt',
      PAYMENT_TYPE: 'Tegund greiðslu: {{paymentType}} ',
      TOTAL_REVENUE: 'Heildartekjur',
      TOTAL_DEDUCTIONS: 'Frádráttur alls',
      NET_SETTLEMENT: 'Netto uppgjör',
      CATEGORY: 'Flokkur',
      COUNT: 'Fjöldi',
      AMOUNT: 'Upphæð',
      SUB_TOTAL: 'Samtals',
      merchantName: 'Fyrirtæki',
      merchantDailyName: 'Daglegt nafn',
      merchantAddress: 'Heimilisfang',
      merchantZip: 'Póstnúmer',
      merchantCity: 'Staður',
      merchantCountry: 'Land',
      merchantId: 'Rammasamningur',
      agreementNumber: 'Samningsnúmer',
      settlementNumber: 'Uppgjörsnúmer',
      chargeCurrency: 'Gjaldmiðill',
      settlementDate: 'Dagsetning',
      period: 'Tímabil',
      paymentDate: 'Greiðsludagur',
      bankAccount: 'Bankareikningur',
    },
    korta_unsettled_payments: {
      header: 'Óuppgerðar greiðslur',
      details: 'Nánar',
      chargeCurrency: 'Gjaldmiðill',
      netSettlement: 'Nettó uppgjör',
      settlementNumber: 'Uppgjörsnúmer',
      settlementDate: 'Uppgjörsdagur',
      acquiringContractDescription: 'Lýsing',
      agreementNumber: 'Samningsnúmer',
      from: 'Frá*',
      to: 'Til*',
      merchantId: 'Rammasamningur',
      acquiringContractId: 'Kortasamningar',
    },
    korta_icelandic_payments: {
      header: 'Íslenskar greiðslur',
      merchantIdDropdown: 'Rammasamningur',
      customerIdDropdown: 'Söluaðili',
      onlyUncomplete: 'Sýna aðeins ókláraðar',
      statusId: 'Staða',
      dateType: 'Tegund dagsetningar*',
      from: 'Frá*',
      to: 'Til*',
      dateTypeOptionsEstimate: 'Áætlaður greiðsludagur',
      dateTypeOptionsOriginal: 'Upprunalegur greiðsludagur',
      acquiringContractId: 'Kortasamningur',
      customerId: 'Auðkenni söluaðila',
      estimatedPaymentDate: 'Áætlaður greiðsludagur',
      merchantDailyName: 'Daglegt nafn rammasamnings',
      merchantId: 'Auðkenni rammasamnings',
      merchantName: 'Nafn rammasamnings',
      originalPaymentDate: 'Upphaflegur greiðsludagur',
      paymentAmount: 'Upphæð greiðslu',
      paymentComment: 'Athugasemd',
      paymentCreatedDate: 'Greiðsla stofnuð',
      paymentCurrency: 'Gjaldmiðill greiðslu',
      paymentRequestId: 'Auðkenni greiðslubeiðni',
      paymentStatus: 'Staða á greiðslu',
      paymentStatusId: 'Auðkenni greiðslustöðu',
      receiverAccountNumber: 'Reikningsnúmer viðtakanda',
      receiverNationalId: 'Kennitala viðtakanda',
      settlementReportId: 'Auðkenni uppgjörsskýrslu',
      transferAccountNumber: 'Greiðandi',
    },
    korta_incoming_batch: {
      header: 'Bunkar inn',
      details_header: 'Ítarupplýsingar um komandi lotu',
      tabs: {
        BATCH_DETAILS: 'Ítarupplýsingar um lotu',
        CONFIRMED_TRANSACTIONS: 'Staðfestar færslur',
        UNCONFIRMED_TRANSACTIONS: 'Óstaðfestar færslur',
        CHANGE_HISTORY: 'Breytingasaga',
      },
      BATCH_DETAILS: 'Ítarupplýsingar um lotu',
      MERCHANT_ID: 'Auðkenni rammasamnings',
      TERMINAL_NUMBER: 'Útstöð',
      BATCH_REFERENCE: 'Tilvísunarnúmer bunka',
      TIME: 'Tími',
      DATE_FROM_TERMINAL: 'Dags. frá útstöð',
      DATE_RECEIVED: 'Dags. móttekið',
      TIME_RECEIVED: 'Tími móttekið',
      AMOUNTS: 'Upphæðir',
      UNCONFIRMED_TRANSACTIONS: 'Óstaðfestar færslur',
      DEBIT_RECORDS_NUMBER: 'Fjöldi debit',
      CREDIT_RECORDS_NUMBER: 'Fjöldi færslna',
      DEBIT_AMOUNT: 'Debit fjárhæð',
      CREDIT_AMOUNT: 'Kredit fjárhæð',
      STATUS: 'Staða',
      STATUS_TIME: 'Stöðutími',
      statuses: {
        P: 'OK',
        E: 'Villa',
        X: 'Hætt við',
        H: 'Bið',
      },
      column: {
        id: 'Ítarupplýsingar',
        transactionId: 'Auðkenni færslu',
        merchantId: 'Auðkenni rammasamnings',
        cardNumber: 'Kortanúmer',
        date: 'Dagsetning',
        time: 'Tími',
        amount: 'Upphæð',
        currency: 'Gjaldmiðill',
        type: 'Tegund',
        authCode: 'Staðfestingarkóði',
        reference: 'Tilvísun',
        outgoingBatch: 'Lota á útleið',
        incomingBatch: 'Komandi lota',
        terminal: 'Endastöð',
        arn: 'Arn',
        cardType: 'Kortategund',
        contractId: 'Auðkenni samnings',
        terminalId: 'Auðkenni endastöðvar',
      },
      table_columns: {
        details: 'Nánar',
        batchReference: 'Tilvísunarnúmer bunka',
        dateFromTerminal: 'Dags. frá útstöð',
        dateReceived: 'Dags. móttekið',
        timeReceived: 'Tími móttekið',
        debitRecordsNumber: 'Fjöldi debit',
        creditRecordsNumber: 'Fjöldi færslna',
        status: 'Staða',
        id: 'Auðkenni bunka',
        merchantId: 'Auðkenni rammasamnings',
        terminalNumber: 'Útstöð',
        debitAmount: 'Debit fjárhæð',
        creditAmount: 'Kredit fjárhæð',
        statusTime: 'Stöðutími',
        transactionsNumber: 'Fjöldi færslna',
        outgoingBatches: 'Bunkar út',
      },
      filters: {
        reference: 'Tilvísun',
        general_search: 'Almenn leit',
        merchantIdDropDown: 'Rammasamningur',
        batchReference: 'Tilvísunarnúmer bunka',
        status: 'Staða',
        from: 'Frá*',
        fromTime: 'Frá tíma*',
        to: 'Til*',
        toTime: 'Til tíma*',
      },
    },
    korta_outgoing_batch: {
      header: 'Bunkar út',
      batch_types: {
        visa: 'Visa',
        mastercard: 'Mastercard',
        korta: 'Korta',
        fgm: 'FGM',
        borgun: 'Borgun',
      },
      statuses: {
        S: 'Sent',
        C: 'OK',
        E: 'Villa',
        X: 'Hætt við',
      },
      filters: {
        general_search: 'Almenn leit',
        merchantIdDropDown: 'Rammasamningur',
        status: 'Staða',
        batchType: 'Tegund bunka',
        from: 'Frá*',
        fromTime: 'Frá tíma*',
        to: 'Til*',
        toTime: 'Til tíma*',
        reference: 'Tilvísun',
        batchReference: 'Tilvísunarnúmer',
      },
      column: {
        incomingBatchStamp: 'Bunka tilvísun',
        batchReference: 'Tilvísunarnúmer',
        dateOfCreation: 'Dags. búið til',
        batchType: 'Tegund bunka',
        approvedNumber: 'Hafnað fjöldi',
        rejectedNumber: 'Samþykkt fjöldi',
        status: 'Staða',
        merchantId: 'Auðkenni rammasamnings',
        timeOfCreation: 'Dags. búið til',
        receivingAcqMerchantNbr: 'Rammasamningur',
        debitAmount: 'Debit fjárhæð',
        debitRecordsNumber: 'Fjöldi debit',
        creditRecordsNumber: 'Fjöldi færslna',
        creditAmount: 'Kredit fjárhæð',
        approvedAmount: 'Samþykkt upphæð',
        rejectedAmount: 'Hafnað upphæð',
        submissionStamp: 'Submission stamp',
        currency: 'Gjaldmiðill',
        statusTime: 'Stöðutími',
        transactionsNumber: 'Færslur',
        incomingBatch: 'Innbunki',
      },
    },
    korta_accounting_files: {
      header: 'Bókhaldsskrár',
      merchantId: 'Rammasamningur',
      from: 'Frá*',
      fetchSinceLastTime: 'Sækja allt sem er ósótt',
      fetchByTime: 'Sækja eftir tímabili',
      to: 'Til*',
      download: 'Sækja',
      emptyResult: 'Engum gögnum skilað',
    },
    korta_settlement_accounts: {
      general_search: 'Almenn leit',
      merchantIdDropDown: 'Rammasamningur',
      acquiringContractId: 'Kortasamningar',
      header: 'Uppgjörsreikningar',
      transactionCurrency: 'Gjaldmiðill færslu',
      settlementCurrency: 'Uppgjörsgjaldmiðill',
      accountNumber: 'Reikningsnúmer',
      accountIdNumber: 'Kennitala',
      swift: 'Swift',
    },
    korta_chargebacks: {
      header: 'Endurkröfur',
      id: 'Auðkenni',
      businessEntity: 'Rekstrareining',
      centralProcessingDate: 'Vinnsludagur',
      dateCreated: 'Dagsetning stofnunar',
      statusOfChargeback: 'Staða endurkröfu',
      acquiringContractId: 'Kortasamningar',
      transactionDate: 'Færsludagur',
      transactionId: 'Auðkenni færslu',
      transactionAmount: 'Upphæð færslu',
      transactionCurrency: 'Gjaldmiðill færslu',
      acquirerReferenceData: 'Tilvísunarnúmer umsækjanda',
      chargebackAmount: 'Upphæð endurkröfu',
      chargebackCurrency: 'Gjaldmiðill endurkröfu',
      caseNumber: 'Málsnúmer',
      rolCaseNumber: 'Rol málsnúmer',
      messageFromMember: 'Skilaboð',
      reversalIndicator: 'Afturvísir',
      sequenceNumber: 'Raðnúmer',
      chargebackReasonCode: 'Ástæðukóði',
      merchantId: 'Rammasamningur',
      merchantName: 'Nafn rammasamnings',
      merchantDailyName: 'Daglegt nafn rammasamnings',
      transactionReference: 'Færslutilvísun',
      cardNumber: 'Kortanúmer',
      general_search: 'Almenn leit',
      merchantIdDropDown: 'Rammasamningur',
      from: 'Frá*',
      to: 'Til*',
      status: 'Staða endurkröfu',
      reference: 'Tilvísun',
      referenceField: 'Tilvísun*',
      arn: 'ARN',
      arnField: 'ARN*',
      arn_placeholder: 'Leita eftir ARN númeri (23 stafir)',

      statuses: {
        1: 'Óunnið',
        10: 'Lokað - ekkert aðhafst',
        100: 'Endurkröfu hafnað með skjali',
        101: 'Á bið',
        102: 'Send gögn afturkölluð',
        2: 'Í vinnslu',
        3: 'Lokað - unnið',
        4: 'Lokað - tapað',
        5: 'Arbitration',
        6: 'Gögn send',
        7: 'Pre-arb',
        8: 'Lokað - samþykkt',
        9: 'Endurtekning',
      },
    },
    korta_frauds: {
      id: 'Auðkenni',
      businessEntityName: 'Skema',
      acquiringContractId: 'Kortasamningur',
      transactionId: 'Auðkenni færslu',
      fraudPostedDate: 'Dags. sent',
      transactionDate: 'Færsludagur',
      transactionAmount: 'Upphæð',
      transactionCurrencyCode: 'Gjaldmiðill',
      dateCreated: 'Dagsetning stofnunar',
      merchantName: 'Nafn rammasamnings',
      merchantDailyName: 'Daglegt nafn rammasamnings',
      acquirerReferenceNumber: 'Tilvísunarnúmer umsækjanda',
      authorisationCode: 'Heimildarkóði',
      cardNumber: 'Kortanúmer',
      fraudType: 'Tegund svika',
      chargebackPresent: 'Endurgreiðsla til staðar',
      transactionReference: 'Færslutilvísun',
      merchantIdDropDown: 'Rammasamningur*',
      from: 'Frá*',
      to: 'Til*',
    },
    accountSetup: {
      title: 'Uppsetning bókhalds',
      groupByBatchNumbers: 'Flokka dagbókarfærslur eftir bunkanúmeri',
      hideProjectedSettlementsFromOtherAcquirers: 'Fela áætluð uppgjör frá öðrum eignarhöldum',
      hideCardType: 'Fjarlægja kortategund úr bunkanúmeri',
      accountingSystem: 'Bókhaldskerfi',
      accountingMethod: 'Bókhaldsaðferð',
      dtoSectionDescription: 'Lýsing',
      dtoSectionRecordText: 'Dagbókarfærsla',
      dtoSectionKey: 'Reikningslykill',
      dtoSectionSubKey: 'Lykill aukareiknings',
      oldestUnfetchedDate: 'Elsta dagsetning fyrir ósóttar bókhaldsskrár',
      bookingTypesNames: {
        100: 'Sala',
        101: 'Sala MasterCard',
        102: 'Sala Maestro',
        103: 'Sala Visa',
        104: 'Sala Visa Electron',
        105: 'Sala JCB',
        106: 'Sala Diners',
        107: 'Sala Amex',
        108: 'Sala Discover',
        109: 'Sala Dankort',
        150: 'Sala debitkort',
        151: 'Sala kreditkort',
        200: 'Þóknun',
        201: 'Þóknun Master Card',
        202: 'Þóknun Maestro',
        203: 'Þóknun Visa',
        204: 'Þóknun Visa Electron',
        205: 'Þóknun JCB',
        206: 'Þóknun Diners',
        207: 'Þóknun Amex',
        208: 'Þóknun Discover',
        209: 'Þóknun Dankort',
        250: 'Þóknun debitkort',
        251: 'Þóknun kreditkort',
        300: 'Innborgað',
        301: 'Innborgað af debitkorti',
        310: 'Innborgað af Borgun',
        320: 'Innborgað af kreditkorti',
        400: 'Aurajöfnun',
        401: 'Leiðrétting óskilgreind',
        402: 'Leiðrétting endurkrafna',
        601: 'Vídd/Deild 1',
        602: 'Vídd/Deild 2',
        603: 'Vídd/Deild 3',
      },
    },
    korta_common: {
      merchant_id: 'Rammasamningur',
      default_currency: 'ANY',
      reference: 'Tilvísun',
      reference_placeholder: 'Leita eftir tilvísunarnúmeri (allt að 30 stafir)',
      less_options: 'Færri leitarskilyrði',
      show_more: 'Fleiri leitarskilyrði',
    },
  },
};
